import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'
import { BirthPregnancy, BirthPregnancyFetchParams } from '~/interfaces'
import { fetchBirthPregnancy, message } from '~/services'
import { hasObjectValue } from '~/utils'

const UNIQUE_KEY = 'birthPregnancy'

export const useFetchBirthPregnancy = (
  params: BirthPregnancyFetchParams,
  config?: UseQueryOptions<BirthPregnancy, Error>
): UseQueryResult<BirthPregnancy, Error> => {
  const fetcher = async (): Promise<BirthPregnancy> => {
    try {
      return await fetchBirthPregnancy(params)
    } catch (error) {
      if (typeof error === 'string') throw new Error(error)
      throw new Error(message('messages.genericUnexpectedError'))
    }
  }

  const hasParams = (): boolean => hasObjectValue({ params })

  return useQuery<BirthPregnancy, Error>([UNIQUE_KEY, params], fetcher, {
    cacheTime: Infinity,
    staleTime: Infinity,
    enabled: hasParams(),
    ...config
  })
}
